<template>
  <div id="app">
    <!--导航条-->
    <gheader type="home"></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <div class="row-agreement">
      <div class="main-width">
        <div id="agreement">
          <h2 id="title">供应商操作手册</h2>
          <div id="source">
            <p></p>
          </div>
          <div id="content">
            
            <h3>一、供应商须知</h3>
            <p class="text-padding">尊敬的供应商：</p>
            <p class="text-padding">您好！</p>
            <p class="text-padding">目前友云采已经上线了网上招标采购系统，未来我们会招标的很多流程都会放在网上，期待您注册网上招采平台跟友云采长期合作。</p>
            <p class="text-padding">为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。</p>
  
            <h3>二、供应商注册申请流程-企业用户注册</h3>
            <div class="manual-img">
              <img src="static/imgs/manual_0.png" alt="">
            </div>
            <h4>1.网上招采地址</h4>
            <p class="text-padding">请在浏览器中输入地址https://yc.yonyoucloud.com/smisupply/home.html登陆城投水务供应商资料信息完善门户。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_.png" alt="">
            </div>

            <h4>2.供应商注册</h4>
            <p class="text-padding">希望参加友云采采购招标的供应商需要在网上申请成为友云采的供应商。</p>
            <h5>2.1 开始注册</h5>
            <p class="text-padding">点击“供应商注册”按钮开始注册。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1.png" alt="">
            </div>
            <h5>2.2 确认相关条款</h5>
            <p class="text-padding">同意并继续后开始填写相关资料</p>
            <div class="manual-img">
              <img src="static/imgs/manual_2.png" alt="">
            </div>
            <h5>2.3 填写账号信息</h5>
            <p class="text-padding">手机号：需要用手机号进行注册（一个手机号只能注册一个账号）</p>
            <p class="text-padding">账号：即登录友云采进行报名，投标等操作的账号（账号必须是唯一的无法重复）</p>
            <p class="text-padding">密码：账户的密码</p>
            <p class="text-padding">企业名称：请确认是公司全称，注册后无法修改。</p>
            <p class="text-padding">相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”</p>
            <div class="manual-img">
              <img src="static/imgs/manual4.png" alt="">
            </div>
            <h5>2.4 回到首页</h5>
            <p class="text-padding">点击“供应商资料信息完善” -进入登录页面 - 点击“忘记密码”</p>
            <div class="manual-img">
              <img src="static/imgs/manual5.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual6.png" alt="">
            </div>
            <h5>2.5 找回密码</h5>
            <p class="text-padding">重新设定密码</p>
            <div class="manual-img">
              <img src="static/imgs/manual7.png" alt="">
            </div>
            <h5>2.6 供应商资料信息完善</h5>
            <p class="text-padding">点击“登录”</p>
            <div class="manual-img">
              <img src="static/imgs/manual8.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual9.png" alt="">
            </div>

            <h4>3.完善资质信息</h4>
            <p class="text-padding">3.1 完善供应商资质信息</p>
            <p class="text-padding">供应商名称：由上一步代入</p>
            <p class="text-padding">管理组织：即确定您提交的资料由哪一家公司审核，选择分公司对应的本部，比如“供水公司本部” 。</p>
            <p class="text-padding">供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件号。供应商还可以新增资质证件。</p>
            <p class="text-padding">供应品类：即您要申请的供货类别，请选择到最末级（请如实填写），<span class="redFont">所有上传的附件以及证件都需要提交资料须企业法人代表签字并加盖单位公章；国外供应商应提供相应的资料，外文版资料应提供相应中文翻译件</span></p>
            <p class="text-padding">继续完善资料</p>
            <p class="text-padding">相关资料填写完成后点击“提交采购商审核即可”</p>
            <div class="manual-img">
              <img src="static/imgs/manual10.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual11.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual12.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual13.png" alt="">
            </div>
            <p class="text-padding">(1).如果资质证件到期日为无限定日期，则在发证日期+50年，比如发证日期2003年10月9日，则到期日为2053年10月9日。</p>
            <p class="text-padding">(2).供应商资质信息点击“添加资质”即跳出资质选择弹窗，可以通过快速搜索进行查找，然后勾选，另外也可以通过点击左侧分类查找，选中对应的资质等级</p>
            <div class="manual-img">
              <img src="static/imgs/manual14.png" alt="">
            </div>
            <p class="text-padding">(1).供应品类则选择对应提供的服务，选择最末级的类别，建议主要选择与城投发生业务往来的服务项</p>
            <p class="text-padding">(2).资质信息全部完善之后，点击“提交审核”即可</p>

            <h4>4.供应商申请结果查询</h4>
            <p class="text-padding">4.1 查看供应商审核是否通过</p>
            <p class="text-padding">(1).账号登录</p>
            <p class="text-padding">供应商登录账号，登录后点击进入工作台。</p>
            <div class="manual-img">
              <img src="static/imgs/manual15.png" alt="">
            </div>
            <p class="text-padding">(2).查看供应商申请界面，点击左侧“客户管理”，点击“我的申请”即可</p>
            <div class="manual-img">
              <img src="static/imgs/manual16.png" alt="">
            </div>
            <p class="text-padding">(3).查看审核是否通过</p>
            <p class="text-padding">待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以进入云采平台供应商档案。</p>
            <div class="manual-img">
              <img src="static/imgs/manual17.png" alt="">
            </div>

            <h3>三、管理组织准入审批操作流程</h3>
            <h4>1.采购方管理组织审核</h4>
            <p class="text-padding">供应商注册提交后，采购方管理组织权限的人员进入工作台后，点击“准入管理”查看待审核供应商详情。</p>
            <div class="manual-img">
              <img src="static/imgs/manual18.png" alt="">
            </div>
            <h4>2. 采购方管理组织审核</h4>
            <p class="text-padding">点击“查看详情”，可查看到供应商详情档案，如材料没问题，会判断供应商材料是否为相似供应商，可以点击“合并”，然后点击“准入”</p>
            <div class="manual-img">
              <img src="static/imgs/manual19.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual20.png" alt="">
            </div>
            <p class="text-padding">如果材料有问题，则点击驳回并提交理由，供应商进入工作台在供应商申请单中驳回中，然后重新填写继续提交申请。</p>
            <p class="text-padding">注：可以通过供应商准入状态上的数量计算完善供应商信息的数量，只需计算待审核+已通过的供应商。，右上角的搜素框支持搜索查询供应商。</p>
            <h4>3. 供应商档案</h4>
            <p class="text-padding">点击“查看详情”，可查看到供应商详情档案。</p>
            <div class="manual-img">
              <img src="static/imgs/manual21.png" alt="">
            </div>

          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import {apiLinks} from '../../api/links.js'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav
    },
    data () {
      return {}
    },
    methods: {
      enterlink: function () {
        let str = window.location.href
        let array = str.split('?')
        if (array[1] === 'register') {
          window.location.href = apiLinks.register
        } else if (array[1] === 'applyFor') {
          window.location.href = apiLinks.suppliersFor
        }
      }
    }
  }
</script>
<style>
  #agreement {
    width: 980px;
    min-height: 650px;
    margin: 50px auto;
    box-shadow: 0 2px 6px #999;
    _border: 1px #dedede solid;
    padding: 15px;
  }

  #title {
    text-align: center !important;
    font-size: 26px;
    font-weight: 400;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  #source > p {
    width: 950px;
    margin: 0 auto;
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
    color: #999;
    line-height: 30px;
    padding-bottom: 5px;
    text-align: center;
  }

  #content > p {
    font-size: 14px;
    font-family: "Microsoft YaHei", Arial, Verdana, sans-serif;
    background: #ffffff;
    color: #333;
    margin: 0 0 10px;
    line-height: 30px;
  }

  .manual-img {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }

  .manual-img > img {
    width: 800px;
  }

  .text-padding {
    padding-left: 24px;
    padding-right: 24px;
  }

  #content h4, #content h5 {
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 20px;
  }

  #content h3 {
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .text-padding .redFont{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// manual.vue?020e736a